(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-guides-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-guides-section]');
  if (!sections.length) return;

  sections.forEach(section => {
    const swiperEl = section.querySelector('.guider-swiper');
    const prevBtn = section.querySelector('[data-guides-prev]');
    const nextBtn = section.querySelector('[data-guides-next]');

    if (!swiperEl) return;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: false,
      watchOverflow: true,
      resistance: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      breakpoints: {
        1024: {
          spaceBetween: 15,
          slidesPerView: 3
        },
        768: {
          spaceBetween: 12,
          slidesPerView: 2
        }
      }
    });

    nextBtn?.addEventListener('click', () => swiper.slideNext());
    prevBtn?.addEventListener('click', () => swiper.slidePrev());

    // 鼠标移入暂停，移出恢复
    swiperEl.addEventListener('mouseenter', () => {
      swiper.autoplay.pause();
    });
    swiperEl.addEventListener('mouseleave', () => {
      swiper.autoplay.start();
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsFixedOnScroll = this.getAttribute('data-sticky-type') === 'on-scroll-up';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      if (this.headerIsFixedOnScroll) {
        this.header.classList.add('shopify-section-header-fixed-on-scroll');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const headerMenuDesktop = window.matchMedia('(min-width: 990px)');
  const headerHoverDetails = Array.from(document.querySelectorAll('.header-valtinsu .header__inline-menu details'));
  let headerBottomPositionFrame;

  const updateHeaderBottomPosition = () => {
    const header = document.querySelector('.header-valtinsu');
    const headerRect = header?.getBoundingClientRect();
    const headerBottom = headerRect && headerRect.width > 0 && headerRect.height > 0 ? headerRect.bottom : 68;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.ceil(Math.max(headerBottom, 0))}px`
    );
  };

  const requestHeaderBottomPositionUpdate = () => {
    window.cancelAnimationFrame(headerBottomPositionFrame);
    headerBottomPositionFrame = window.requestAnimationFrame(updateHeaderBottomPosition);
  };

  window.updateHeaderBottomPosition = updateHeaderBottomPosition;

  const getHeaderDetailsSummary = (details) => details.querySelector('summary');

  const closeHeaderDetails = (details, animateSuperMenu = true) => {
    const summary = getHeaderDetailsSummary(details);

    window.clearTimeout(details.headerHoverCloseTimer);
    window.clearTimeout(details.headerHoverRemoveOpenTimer);
    summary?.setAttribute('aria-expanded', false);

    if (details.classList.contains('header-super-menu-details') && animateSuperMenu) {
      details.classList.remove('header-super-menu--open');
      details.classList.add('header-super-menu--closing');

      details.headerHoverRemoveOpenTimer = window.setTimeout(() => {
        details.removeAttribute('open');
        details.classList.remove('header-super-menu--closing');
      }, 560);
      return;
    }

    details.removeAttribute('open');
    details.classList.remove('header-super-menu--open', 'header-super-menu--closing');
  };

  const closeOtherHeaderDetails = (activeDetails) => {
    headerHoverDetails.forEach((details) => {
      if (details === activeDetails || details.contains(activeDetails) || activeDetails.contains(details)) return;
      closeHeaderDetails(details, false);
    });
  };

  const openHeaderDetails = (details) => {
    const summary = getHeaderDetailsSummary(details);

    window.clearTimeout(details.headerHoverCloseTimer);
    window.clearTimeout(details.headerHoverRemoveOpenTimer);
    closeOtherHeaderDetails(details);
    updateHeaderBottomPosition();

    details.classList.remove('header-super-menu--closing');
    details.setAttribute('open', '');
    summary?.setAttribute('aria-expanded', true);

    if (details.classList.contains('header-super-menu-details')) {
      window.requestAnimationFrame(() => {
        updateHeaderBottomPosition();
        details.classList.add('header-super-menu--open');
      });
    }
  };

  headerHoverDetails.forEach((details) => {
    const summary = getHeaderDetailsSummary(details);

    details.addEventListener('mouseenter', () => {
      if (!headerMenuDesktop.matches) return;
      openHeaderDetails(details);
    });

    details.addEventListener('mouseleave', () => {
      if (!headerMenuDesktop.matches) return;
      details.headerHoverCloseTimer = window.setTimeout(() => {
        closeHeaderDetails(details);
      }, 120);
    });

    summary?.addEventListener('click', (event) => {
      if (!headerMenuDesktop.matches) return;
      event.preventDefault();
      openHeaderDetails(details);
    });

    details.addEventListener('toggle', () => {
      if (!details.classList.contains('header-super-menu-details')) return;

      if (details.open) {
        window.requestAnimationFrame(() => {
          details.classList.add('header-super-menu--open');
        });
      } else {
        details.classList.remove('header-super-menu--open', 'header-super-menu--closing');
      }
    });
  });

  const setMenuProductSuperMenuPanel = (container, tabIndex) => {
    const tabs = container.querySelectorAll('[data-menu-product-tab]');
    const panels = container.querySelectorAll('[data-menu-product-panel]');

    tabs.forEach((tab) => {
      const isActive = tab.dataset.menuProductTab === tabIndex;
      tab.classList.toggle('header-super-menu-sidebar__item--active', isActive);
      tab.classList.toggle('header-menu-product-super-menu-sidebar__item--active', isActive);
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.menuProductPanel === tabIndex;
      panel.classList.toggle('header-menu-product-super-menu-products__panel--active', isActive);
      panel.hidden = !isActive;
    });
  };

  document.querySelectorAll('.header-menu-product-super-menu-details, .header-menu-product-super-menu-drawer').forEach((container) => {
    container.querySelectorAll('[data-menu-product-tab]').forEach((tab) => {
      const tabIndex = tab.dataset.menuProductTab;

      tab.addEventListener('mouseenter', () => setMenuProductSuperMenuPanel(container, tabIndex));
      tab.addEventListener('focus', () => setMenuProductSuperMenuPanel(container, tabIndex));
      tab.addEventListener('click', (event) => {
        if (!tab.hasAttribute('data-menu-product-drawer-tab')) return;

        event.preventDefault();
        setMenuProductSuperMenuPanel(container, tabIndex);
      });
    });
  });

  headerMenuDesktop.addEventListener('change', (event) => {
    if (event.matches) {
      updateHeaderBottomPosition();
      return;
    }
    headerHoverDetails.forEach((details) => closeHeaderDetails(details, false));
  });

  window.addEventListener('resize', requestHeaderBottomPositionUpdate);
  window.addEventListener('scroll', requestHeaderBottomPositionUpdate, { passive: true });

  const sectionHeader = document.querySelector('.section-header');
  if (sectionHeader) {
    new MutationObserver(requestHeaderBottomPositionUpdate).observe(sectionHeader, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });
  }

  updateHeaderBottomPosition();

  } catch(e) { console.error(e); }
})();
})();
